var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61703 12.2497H1.07734V4.07121H3.61703V12.2497ZM2.34582 2.95559C1.53371 2.95559 0.875 2.28293 0.875 1.47082C0.875 1.08073 1.02996 0.706626 1.30579 0.430793C1.58163 0.154961 1.95573 0 2.34582 0C2.73591 0 3.11001 0.154961 3.38585 0.430793C3.66168 0.706626 3.81664 1.08073 3.81664 1.47082C3.81664 2.28293 3.15766 2.95559 2.34582 2.95559ZM13.1223 12.2497H10.588V8.26848C10.588 7.31965 10.5689 6.10285 9.26762 6.10285C7.94719 6.10285 7.74484 7.13371 7.74484 8.20012V12.2497H5.20789V4.07121H7.64367V5.18684H7.67922C8.01828 4.54426 8.84652 3.86613 10.0822 3.86613C12.6525 3.86613 13.125 5.55871 13.125 7.75715V12.2497H13.1223Z",
    fill: "#EBE9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIn);
export default __webpack_public_path__ + "static/media/linkedin-in.8e41279f18a563d0dd8ddeab3aaae55d.svg";
export { ForwardRef as ReactComponent };